/**
 * Public auth-related URL paths (login, password reset).
 * Used to avoid ProtectedRoute redirects and backend user load during recovery.
 */

export function isPasswordResetPath(pathname) {
  if (!pathname) return false;
  return pathname.includes('/auth/reset-password');
}

export function isLoginPath(pathname) {
  if (!pathname) return false;
  return /\/login\/?$/.test(pathname) || pathname.endsWith('/login');
}

export function isPublicAuthPath(pathname) {
  return isLoginPath(pathname) || isPasswordResetPath(pathname);
}

/**
 * Normalize mistaken reset URLs (e.g. FRONTEND_URL included /casc) when app has no base path.
 * @returns {string|null} Full path+search+hash to redirect to, or null if no change needed
 */
export function getPasswordResetPathCorrection(pathname, search, hash, basePath) {
  const normalizedBase = (basePath || '').replace(/\/+$/, '');
  const wrongPrefix = '/casc/auth/reset-password';
  // Innfall / root deploy: /casc/auth/... is the API prefix, not the SPA — fix email links from old FRONTEND_URL
  if (!normalizedBase && (pathname === wrongPrefix || pathname.startsWith(`${wrongPrefix}/`))) {
    return `/auth/reset-password${search || ''}${hash || ''}`;
  }
  return null;
}
